import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
import { colorGrey00 } from '../../../../tokens';
export var getTypographyOverride = function getTypographyOverride(_ref) {
  var pageTitle = _ref.pageTitle,
      sectionTitle = _ref.sectionTitle,
      subSectionTitle = _ref.subSectionTitle;

  if (pageTitle || sectionTitle || subSectionTitle) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), colorGrey00);
  }

  return {};
};